"use client"

import { useState, useEffect, useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useRouter } from "next/navigation"
import { handleSwissCTAClick } from "../utils/cta"

const SwissHeroSection = () => {
  const [mounted, setMounted] = useState(false)
  const { t } = useTranslation("SwissHeroSection")
  const router = useRouter()

  useEffect(() => {
    setMounted(true)
  }, [])

  const handleCTAClick = useCallback(() => {
    handleSwissCTAClick(router)
  }, [router])

  return (
    <section
      className="relative w-full h-[600px] md:h-[700px] overflow-hidden"
      style={{
        backgroundImage: "url('/hero-swiss.png')", // You can replace with Swiss image later
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-between px-6 py-8 md:py-12">
        {/* Title Section - Top */}
        <div className="flex-1 flex items-start justify-center pt-8 md:pt-16">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-4xl md:text-7xl font-bold leading-tight">
              <span className="text-white drop-shadow-lg">
                {mounted ? t("mainHeader1") : "Learn Swiss German"}
              </span>
              <br />
              <span className="text-red-400 drop-shadow-lg">
                {mounted ? t("mainHeader2") : "with AI"}
              </span>
            </h1>

            {/* <p className="text-lg md:text-2xl mb-8 max-w-3xl mx-auto text-gray-100 drop-shadow-md">
              {t("subheading")}
            </p> */}
          </div>
        </div>

        {/* CTA Section - Bottom */}
        <div className="flex-shrink-0 text-center pb-8 md:pb-16">
          <button
            onClick={handleCTAClick}
            className="bg-red-500 hover:bg-red-600 text-white text-lg md:text-xl font-semibold px-8 py-4 rounded-full shadow-2xl transition duration-300 transform hover:scale-105"
          >
            {mounted ? t("ctaButton") : "Start Learning"}
          </button>
        </div>
      </div>
    </section>
  )
}

export default SwissHeroSection
